import { render, staticRenderFns } from "./cognitivebehaviorald.vue?vue&type=template&id=55141081&scoped=true&"
import script from "./cognitivebehaviorald.vue?vue&type=script&lang=js&"
export * from "./cognitivebehaviorald.vue?vue&type=script&lang=js&"
import style0 from "./cognitivebehaviorald.vue?vue&type=style&index=0&id=55141081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55141081",
  null
  
)

export default component.exports